
import React, { useEffect, useState } from "react";
import { useSubheader } from "@metronic/layout";
import {
  Alert,
  Col,
  Row,
  Card,
  Accordion,
  Button,
  Form,
} from "react-bootstrap";
import {Redirect, useHistory} from "react-router-dom";
import axios from "axios";
import { InssuredData } from "@components/panels/insured-data/inssured-data";
import { HospitalData } from "@components/panels/hospital-data/hospital-data";
import { Documentation } from "@components/panels/documentation/documentation";
import { Binnacle } from "@components/panels/binnacle/binnacle";
import { MedicalOpinionData } from "@components/panels/medical-opinion-data/medical-opinion-data";
import { MedicalDataAdditional } from "@components/panels/additional-medical-data/medical-data-additional";
import { AuthLetters } from "@components/panels/auth-letter/auth-letters";
import { SurgeryProvidersSection } from "@components/panels/surgery-providers-section/surgery-providers-section";
import { SufferingData } from "@components/panels/suffering-data/suffering-data";
import {
  getBySlug,
  update,
} from "@services/hospitalization";
import {
  getLastLetterMovByCase,
  getLetterMovsByCase,
} from "@services/letter-movements";
import { MedicAssigned } from "@components/panels/medic-assigned/medic-assigned";
import moment from "moment";
import { isEmpty } from "@utils/check-object-empty";
import { MedicAssignationTrakingMedic } from "@components/panels/medic-assignation-tracking/medic-assignation-tracking-medic";
import { IfHasRole } from "@metronic/_helpers";
import { MedicalFees } from "@components/panels/medical-fee/medical-fees";
import CaseHeader from "@components/panels/case-header/case-header";
import BlockCaseContext from "@contexts/block-case-context";
import { useCommentValidation } from "@contexts/comment-validation-context";
import WithCommentValidation from "@components/shared/with-comment-validation";
import NotificationModal from "@components/shared/notification-modal";
import $ from "jquery";
import {isCaseInCorrectModule} from "@utils/check-module-status";
import {CASE_STATUS} from "@constants/case-statuses";
import { useAutomaticCommentSave } from "@hooks/use-automatic-comment-save";
import { getMexicoTimestamp } from "@utils/date-utils";
import { hasAnyCompleteSuffering } from "@services/sufferings-data";

const DICTUM_AUTORIZADO_MESSAGE =
  "Para dejar el dictamen en Autorizado, el apartado Datos Padecimiento debe tener al menos un registro con ICD, descripción ICD, ICD Especialidad, CPT, descripción CPT y CPT Especialidad completos.";

const MedicalOpinionDetails = (props) => {
  const [caseRecord, setCaseRecord] = useState({});
  const [letterMov, setLetterMov] = useState({});
  const [letterMovs, setLetterMovs] = useState([]);
  const [totalLetters, setTotalLetters] = useState("0");
  const [isFinalReject, setIsFinalReject] = useState(false);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);
  const [notification, setNotification] = useState({ show: false, message: "", variant: "warning" });

  const showNotification = (message, variant = "warning") =>
    setNotification({ show: true, message, variant });

  const hideNotification = () =>
    setNotification((prev) => ({ ...prev, show: false }));

  const validateSufferingIfAuthorized = async () => {
    const statusDictumEl = document.getElementById("statusDictum");
    const statusDictum = statusDictumEl ? statusDictumEl.value : "";
    if (statusDictum && statusDictum.toLowerCase() === "autorizado") {
      const hasComplete = await hasAnyCompleteSuffering(caseRecord.id);
      if (!hasComplete) {
        showNotification(DICTUM_AUTORIZADO_MESSAGE, "warning");
        return false;
      }
    }
    return true;
  };

  const subheader = useSubheader();
  const { validateCommentRequired } = useCommentValidation();
  const { saveCommentAutomatically } = useAutomaticCommentSave({ caseData: caseRecord });
  const { saveCommentAutomaticallyUnam } = useAutomaticCommentSave({
    caseData: caseRecord,
    eventStage: null,
    comment: "FAVOR DE FACTURAR A UNAM, DE NO HACERLO NO SE PODRÁ PAGAR",
    isPageable: false,
    hideReason: true,
  });

  const { slug } = props.match.params;

  useEffect(() => {
    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
      setIsFinalReject(response.data.statusDictum === "Rechazo Definitivo")
      getLastLetterMovByCase(response.data.id).then((currrentLetterMov) =>
        setLetterMov(currrentLetterMov.data)
      );
    });

    subheader.setTitle("DICTAMEN MÉDICO");
  }, [slug]);

  let history = useHistory();
  let submitMedicalOpinionData = null;
  let submitMedicalDataAdditional = null;
  let submitMedicalOpinionDataErrors = null;

  const query = new URLSearchParams(props.location.search);

  const bindSubmitFormMedicalOpinionData = (submitForm) =>
    (submitMedicalOpinionData = submitForm);

  const bindSubmitFormMedicalDataAdditional = (submitForm) =>
    (submitMedicalDataAdditional = submitForm);

    const bindSubmitMedicalOpinionErrors = (errors) =>
    (submitMedicalOpinionDataErrors = errors);

  let submitFormMedicAssignation = null;
  let submitFormMedicAssignationErrors = null;

  const bindSubmitFormMedicAssignation = (submitForm) =>
    (submitFormMedicAssignation = submitForm);

  const bindSubmitFormMedicAssignationErrors = (errors) =>
    (submitFormMedicAssignationErrors = errors);

  const onClickSendControlDesk = async () => {
    if (!(await validateSufferingIfAuthorized())) return;

    await submitMedicalOpinionData();
    if (isEmpty(submitMedicalOpinionDataErrors)) {
      let inputReasonControlDesk = document.getElementById(
        "reason_sendToControlDesk"
      ).value;
      if (inputReasonControlDesk === "") {
        showNotification("Debe seleccionar una razón.", "warning");
        return;
      }
      if (!validateCommentRequired()) {
        return;
      }
      await saveCommentAutomatically();
      await saveCommentAutomaticallyUnam();
      let timestamp = getMexicoTimestamp();
      update(
        { caseStatusId: 2, reasonMC: inputReasonControlDesk, feamesaControl: timestamp },
        caseRecord.id
      ).then((response) => {
        history.push("/dictamen_medico");
      });
    }
  }

  const onClickCostControl = async () => {
    if (caseRecord.caseType === "Alta hospitalaria" && document.getElementById("si").value === "si" && !caseRecord.nurseFollowId) {
      showNotification(
        "El caso no cuenta con Enfermer@ Asignad@ para el seguimiento en el siguiente módulo, favor de reportarlo a mesa de control.",
        "warning"
      );
      return;
    }

    if (!(await validateSufferingIfAuthorized())) return;

    await submitMedicalOpinionData();
    if (isEmpty(submitMedicalOpinionDataErrors)) {
      var someLetterAuthIsFinal;
      await submitMedicalDataAdditional();
      await getLetterMovsByCase(caseRecord?.id).then( result => {
        setLetterMovs(result.data);
        someLetterAuthIsFinal = result.data.some(letterMov => letterMov.letterType === "Final");
      });

      if (caseRecord.caseType !== "Reconsideracion de dictamen" && caseRecord.caseType !== "Alta express" && caseRecord.caseType !== "Revision de corte" && !isFinalReject) {
        if ( (caseRecord.caseType !== "Alta hospitalario" && caseRecord.caseType !== "Alta hospitalaria"
            && caseRecord.caseType !== "Reconsideración de Alta") || !document.getElementById('si').checked) {
          showNotification(
            "No se puede enviar el caso a este módulo porque no es Alta Hospitalaria y la Carta no es Suficiente.",
            "warning"
          );
          return;
        }
      }

      if (!validateCommentRequired()) {
        return;
      }
      await saveCommentAutomatically();
      await saveCommentAutomaticallyUnam();
      let timestamp = getMexicoTimestamp();
      update(
        { caseStatusId: 6, feaccostos: timestamp },
        caseRecord.id
        ).then((response) => {
        history.push("/dictamen_medico");
      });
    }
  }

  const onClickSendMedicInformation = async () => {
    if (!(await validateSufferingIfAuthorized())) return;

    await submitMedicalOpinionData();
    if (isEmpty(submitMedicalOpinionDataErrors)) {
      let inputReasonMedicInformation = document.getElementById(
        "reason_sendToMedicInformation"
      ).value;
      if (inputReasonMedicInformation === "") {
        showNotification("Debe seleccionar una razón.", "warning");
        return;
      }

      if (inputReasonMedicInformation === "Informacion medica adicional") {
        let checkboxesMedicalDataAdditional = Array.prototype.slice.call(
          document.getElementsByName("additionalMedicInformation")
        );
        let someValueIsChecked = checkboxesMedicalDataAdditional.some(
          (checkbox) => checkbox.checked
        );
        if (!someValueIsChecked) {
          showNotification(
            "Debes seleccionar un checkbox de Información Médica Adicional.",
            "warning"
          );
          return;
        }
      }

      await submitMedicalDataAdditional();
      if (!validateCommentRequired()) {
        return;
      }
      await saveCommentAutomatically();
      await saveCommentAutomaticallyUnam();
      let timestamp = getMexicoTimestamp();
      update(
        { caseStatusId: 4, informationReason: inputReasonMedicInformation, feaimedica: timestamp },
        caseRecord.id
      ).then((response) => {
        history.push("/dictamen_medico");
      });
    }
  }

  const onClickSendHospitalSupervision = async () => {
    if (!(await validateSufferingIfAuthorized())) return;

    await submitMedicalOpinionData();
    if (isEmpty(submitMedicalOpinionDataErrors)) {
      const inputReasonHospitalSupervision = document.getElementById("reason_sendToHospitalSupervision").value;
      if (inputReasonHospitalSupervision === "") {
        showNotification("Debe seleccionar una razón.", "warning");
        return;
      }

      if (!validateCommentRequired()) {
        return;
      }

      await saveCommentAutomatically();
      await saveCommentAutomaticallyUnam();

      let timestamp = getMexicoTimestamp();
      update({
            caseStatusId: CASE_STATUS.HOSPITAL_SUPERVISION,
            reasonHospitalSupervision: inputReasonHospitalSupervision,
          }, caseRecord.id)
          .then((response) => {
            history.push("/supervision_hospitalaria");
          });
    }
  }

  if (!isCaseInCorrectModule(caseRecord, [CASE_STATUS.MEDICAL_OPINION])) {
    return <Redirect to="/error/unauthorized"/>;
  }

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        DICTAMEN MÉDICO
      </Alert>

      <CaseHeader caseRecord={caseRecord} enableHospitalSupervisionStatus={true} showSpecialities={true} />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
      <Accordion defaultActiveKey={query.has("from") && query.get("from") === "control_board" ? "" : "3"} className="mt-5">
        <InssuredData
          icon="fa-search"
          eventKey="1"
          data={caseRecord}
          disabledAll={true}
          bindSubmitForm={() => {}}
        />
        <HospitalData
          icon="fa-search"
          eventKey="2"
          data={caseRecord}
          disabledAll={true}
          bindSubmitForm={() => {}}
        />
        <MedicAssigned
          icon="fa-search"
          eventKey="7"
          data={caseRecord}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          bindSubmitForm={() => {}}
        />
        <Documentation
          icon= "fa-search"
          icone="fa-pencil-alt"
          eventKey="4"
          data={caseRecord}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          {...props}
        />
        <MedicalFees
          icon= "fa-search"
          icone="fa-pencil-alt"
          eventKey="5"
          data={caseRecord}
          hideBtnInsurance={false}
          hideFormCreate={true}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          showForm={!query.has("from") && query.get("from") !== "control_board"}
          ableToHideAuthLetters={true}
          {...props}
        />
        <SurgeryProvidersSection
            icon="fa-search"
            eventKey="6"
            data={caseRecord}
            disabled={false}
            disabledAll={true}
            {...props}
        />
        <AuthLetters
          icon="fa-pencil-alt"
          showForm={true}
          eventKey="3"
          data={caseRecord}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          setTotalLetters={setTotalLetters}
          {...props}
        />
        <SufferingData
          icon="fa-pencil-alt"
          eventKey="8"
          data={caseRecord}
          disabledAll={false}
          bindSubmitForm={() => {}}
        />
      </Accordion>
      <Accordion  defaultActiveKey={query.has("from") && query.get("from") === "control_board" ? "" : "0"} key={1} className="mt-5">
        { (IfHasRole("Admin") || IfHasRole("ADMINAXA") || IfHasRole("ADMIN_REGION_CELULA") || IfHasRole("DICTAMEN-CONTLCOSTOS") ) && <MedicAssignationTrakingMedic
          icon="fa-pencil-alt"
          eventKey="0"
          data={caseRecord}
          mcMovement={letterMov}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          bindSubmitForm={bindSubmitFormMedicAssignation}
          bindErrors={bindSubmitFormMedicAssignationErrors}
        /> }
        <MedicalOpinionData
          icon="fa-pencil-alt"
          setIsFinalReject={setIsFinalReject}
          eventKey="1"
          data={caseRecord}
          letterMov={letterMov}
          totalLetters={totalLetters}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          bindSubmitForm={bindSubmitFormMedicalOpinionData}
          bindErrors={bindSubmitMedicalOpinionErrors}
        />
        <MedicalDataAdditional
          icon="fa-pencil-alt"
          eventKey="6"
          data={caseRecord}
          disabled={query.has("from") && query.get("from") === "control_board"}
          bindSubmitForm={bindSubmitFormMedicalDataAdditional}
        />
      </Accordion>
      <Accordion defaultActiveKey="5" className="mt-5">
        <Binnacle
          icon="fa-pencil-alt"
          eventKey="5"
          data={caseRecord}
          disabledAll={false}
          eventStage="Dictamen Medico"
          {...props}
        />
      </Accordion>
      </BlockCaseContext.Provider>

      <Row hidden={query.has("from") && query.get("from") === "control_board"}>
        {caseRecord.caseType !== "Revision de corte" &&
        <Col className="mt-5" hidden={isFinalReject}>
          <Button variant="warning" onClick={onClickSendMedicInformation}>
            Enviar a Informacion Médica Hospital
          </Button>

          <Form.Control
            className="mt-5 mr-3"
            as="select"
            name="reason_sendToMedicInformation"
            id="reason_sendToMedicInformation"
          >
            <option value="">Selecciona una opcion...</option>
            <option value="Informacion medica adicional">
              Informacion medica adicional
            </option>
            <option value="Carta parcial">Carta parcial</option>
          </Form.Control>
        </Col>}

        {caseRecord.caseType !== "Revision de corte" &&
        <Col className="mt-5 mr-5" hidden={isFinalReject}>
          <Button variant="danger" onClick={onClickSendControlDesk}>
            Enviar a Mesa de Control
          </Button>

          <Form.Control
            className="mt-5 mr-3"
            as="select"
            name="reason_sendToControlDesk"
            id="reason_sendToControlDesk"
          >
            <option value="">Selecciona una opcion...</option>
            <option value="Asignacion Incorrecta">Asignacion Incorrecta</option>
            <option value="Poliza VIP">Poliza VIP</option>
            <option value="Información Adicional">Información Adicional</option>
            <option value="Caso Inicial">Caso Inicial</option>
            <option value="Asignación Incorrecta VIP">Asignación Incorrecta VIP</option>
            <option value="Asignación Incorrecta VIP">Asignación Incorrecta Agil</option>
          </Form.Control>
        </Col>}

        <Col>
          <Button
            className="mt-5"
            variant="success"
            onClick={onClickCostControl}
          >
            Enviar a Control de Costos
          </Button>
        </Col>

        <Col className="mt-5 mr-5">
          <Button variant="danger" onClick={onClickSendHospitalSupervision}>
            Enviar a Supervisión Hospitalaria
          </Button>

          <Form.Control
              className="mt-5 mr-3"
              as="select"
              name="reason_sendToHospitalSupervision"
              id="reason_sendToHospitalSupervision"
          >
            <option value="">Selecciona una opcion...</option>
            <option value="Sobreutilización">Sobreutilización</option>
            <option value="Sobrecosto">Sobrecosto</option>
            <option value="Aclaración">Aclaración</option>
            <option value="Caso Inicial">Caso Inicial</option>
            <option value="Falta de Informacion">Falta de Informacion</option>
          </Form.Control>
        </Col>
      </Row>

      <NotificationModal
        show={notification.show}
        onHide={hideNotification}
        message={notification.message}
        variant={notification.variant}
      />
    </>
  );
};

export default WithCommentValidation(MedicalOpinionDetails);

